import { action, makeObservable, observable } from "mobx";
import { NumberNull, UserShopOrderGood } from "../../interfaces";

export class UserShopOrderGoodStore implements UserShopOrderGood {
	@observable id = 0;
	@observable title = "";
	@observable rate = "";
	@observable grand_chart_id: NumberNull = null;
	@observable price_ruble = 0;
	@observable price_dollar = 0;
	@observable shop_good_plans_id = 0;
	@observable shop_good_period_id = 0;
	@observable instrument_id = 0;
	@observable included_grand_chart_ids: Array<number> = [];

	constructor(initialData: UserShopOrderGood | null) {
		makeObservable(this);

		if (initialData) {
			this.fillStore(initialData);
		}
	}

	@action
	fillStore(data: UserShopOrderGood) {
		const {
			id,
			title,
			rate,
			grand_chart_id,
			price_ruble,
			price_dollar,
			shop_good_plans_id,
			shop_good_period_id,
			instrument_id,
			included_grand_chart_ids,
		} = data;

		this.id = id;
		this.title = title;
		this.rate = rate;
		this.grand_chart_id = grand_chart_id;
		this.price_ruble = price_ruble;
		this.price_dollar = price_dollar;
		this.shop_good_plans_id = shop_good_plans_id;
		this.shop_good_period_id = shop_good_period_id;
		this.instrument_id = instrument_id;
		this.included_grand_chart_ids = included_grand_chart_ids || [];
	}
}
